module.exports = __webpack_public_path__ + "static/media/hanmu_m.8dc97320.png";